import 'react-app-polyfill/ie11';
import 'react-app-polyfill/stable';
import '@fortawesome/fontawesome-free/css/all.min.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'animate.css/animate.min.css';
import "../style.css"
import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import {initAnalytics} from './analytics';

initAnalytics();

ReactDOM.render(<App />, document.getElementById('root'));
